import React from 'react';
import { motion } from 'framer-motion';

function ShowChibi(props) {

        return (
                <div>              
                                        
                        <motion.img
                        transition={{ 
                                duration: 0.5,
                                ease: "easeOut"
                        }}
                        animate={{ y: ["10rem", "0rem"]}}
                        className='chibiAnimation'
                        src={props.src} />
                
                        
                </div>
        );

}

export default ShowChibi; 




